//@flow
import _ from 'lodash';
import * as React from 'react';
import { TableHeaderColumn } from 'react-bootstrap-table';
import {
  Button,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  FormGroup,
} from 'reactstrap';
import connect from 'react-redux/es/connect/connect';
import ListagemPage from '../../components/templates/ListagemPage';
import { hasClienteComPA } from '../../helpers/permissions.helper';
import { tableHelper } from '../../helpers/tableHelper';
import withAbility from '../../hoc/withAbility';
import { pedidosService } from '../../services/pedidos.service';
import TopoTitleComponente from '../Topo/TopoTitleComponente';
import PedidosCrudListFilter from './PedidosCrudListFilter';

const STORAGE_KEY = 'pedidos.columns.visible';
const endPoint = '/pedidos/novo/';
const endPointView = '/pedidos/edit/';

type State = {
  labels: string[],
  fields: string[],
  visibleKeys: { [key: string]: boolean },
  chooserOpen: boolean,
};

class PedidosCrudList extends React.PureComponent<{}, State> {
  constructor(props) {
    super(props);

    const isSudo =
      props.user && props.user.perfis && props.user.perfis.indexOf('SUDO') > -1;
    const clienteHasPA = hasClienteComPA();

    this.columns = [
      {
        path: 'statusInterno',
        title: 'STATUS',
        isStatusPedido: true,
        width: '100px',
        priority: 1,
      },
      {
        path: 'numeroPedido',
        title: 'Número do pedido',
        isKey: true,
        className: 'txtBold',
        priority: 1,
      },
      ...(clienteHasPA
        ? [
            {
              path: 'numeroPedidoTemporario',
              title: 'Número do pedido Temp',
              priority: 3,
            },
            { path: 'numeroNotaFiscal', title: 'Nota Fiscal', priority: 2 },
          ]
        : []),
      {
        path: 'createdAt',
        title: 'Data de criação',
        isDateTime: true,
        priority: 1,
      },
      ...(isSudo
        ? [{ path: 'cliente.nomeFantasia', title: 'Cliente', priority: 2 }]
        : []),
      ...(clienteHasPA
        ? [
            {
              path: 'pontoAtendimentoNome',
              title: 'Ponto de Atendimento',
              priority: 1,
            },
            {
              path: 'tipoPedido',
              title: 'Tipo do pedido',
              isTipoPedido: true,
              priority: 2,
            },
            { path: 'criadoPorNome', title: 'Criado por', priority: 2 },
            {
              path: 'updatedAt',
              title: 'Data última alteração',
              isDateTime: true,
              priority: 2,
            },
            {
              path: 'aprovadoPorNome',
              title: 'Aprovado/Recusado por',
              priority: 3,
            },
            { path: 'nomePaciente', title: 'Nome do paciente', priority: 2 },
          ]
        : []),
      ...(!clienteHasPA
        ? [
            {
              path: 'numeroPedidoCliente',
              title: 'Nº Pedido Cliente',
              priority: 2,
            },
            {
              path: 'dataHoraColeta',
              title: 'Data hora coleta',
              isDateTime: true,
              priority: 2,
            },
          ]
        : []),
      { path: 'statusAlcis', title: 'Status WMS', priority: 1 },
      {
        path: 'urgente',
        title: 'É urgente',
        yesNo: true,
        className: 'txtBold',
        priority: 1,
      },
    ];

    const fields = this.columns.map(function(col) {
      return col.path;
    });
    const labels = this.columns.map(function(col) {
      return col.title;
    });

    // visibilidade inicial: liga prioridade 1, desliga 3, prioridade 2 liga por padrão
    var initialVisible = {};
    for (var i = 0; i < this.columns.length; i++) {
      var c = this.columns[i];
      initialVisible[c.path] =
        c.priority === 1 ? true : c.priority === 3 ? false : true;
    }

    // carrega preferências do usuário
    try {
      var saved = window.localStorage.getItem(STORAGE_KEY);
      if (saved) {
        var parsed = JSON.parse(saved);
        // só aplica chaves existentes
        for (var k in parsed) {
          if (parsed.hasOwnProperty(k)) {
            initialVisible[k] = parsed[k];
          }
        }
      }
    } catch (e) {}

    this.state = {
      labels: labels,
      fields: fields,
      visibleKeys: initialVisible,
      chooserOpen: false,
    };
  }

  toggleChooser = () => {
    this.setState({ chooserOpen: !this.state.chooserOpen });
  };

  handleToggleColumn = (path) => {
    var next = Object.assign({}, this.state.visibleKeys);
    next[path] = !next[path];
    this.setState({ visibleKeys: next }, function() {
      try {
        window.localStorage.setItem(
          STORAGE_KEY,
          JSON.stringify(this.state.visibleKeys)
        );
      } catch (e) {}
    });
  };

  handleShowEssentials = () => {
    var next = {};
    for (var i = 0; i < this.columns.length; i++) {
      var c = this.columns[i];
      next[c.path] = c.priority === 1;
    }
    this.setState({ visibleKeys: next }, function() {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      } catch (e) {}
    });
  };

  handleShowAll = () => {
    var next = {};
    for (var i = 0; i < this.columns.length; i++) {
      next[this.columns[i].path] = true;
    }
    this.setState({ visibleKeys: next }, function() {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      } catch (e) {}
    });
  };

  handleRowClick = (row /*: any */) => {
    var id = row && row.id ? row.id : null;
    if (id) this.props.history.push(endPointView + id);
  };

  handleNewButton = () => {
    this.props.history.push(endPoint);
    this.props.history.push({
      pathname: endPoint,
      state: { titlePage: 'Novo pedido' },
    });
  };

  // formatter compacto de datas (exemplo de compactação)
  renderDatasCompact = (cell, row, extra) => {
    const colFake = { path: 'createdAt', title: 'Criado em', isDateTime: true };
    const colFake2 = {
      path: 'updatedAt',
      title: 'Atualizado em',
      isDateTime: true,
    };

    const criado = tableHelper.renderCustom(row, row, colFake);
    const atualizado = tableHelper.renderCustom(row, row, colFake2);

    return (
      <div>
        <div>
          <strong>Criado:</strong> {criado}
        </div>
        <div>
          <strong>Atualizado:</strong> {atualizado}
        </div>
      </div>
    );
  };

  // dentro da classe
  renderColumnChooser = () => {
    return (
      <div className="w-100">
        <Dropdown isOpen={this.state.chooserOpen} toggle={this.toggleChooser}>
          <DropdownToggle caret>Colunas</DropdownToggle>
          <DropdownMenu
            style={{ maxHeight: 420, overflow: 'auto', padding: 8 }}
          >
            <div style={{ display: 'flex', gap: 8, margin: '0 8px 8px 8px' }}>
              <Button size="sm" onClick={this.handleShowEssentials}>
                Essenciais
              </Button>
              <Button size="sm" onClick={this.handleShowAll}>
                Exibir todas
              </Button>
            </div>
            {this.columns.map((c) => (
              <DropdownItem
                key={c.path}
                toggle={false}
                onClick={() => this.handleToggleColumn(c.path)}
              >
                <input
                  type="checkbox"
                  readOnly
                  checked={!!this.state.visibleKeys[c.path]}
                  style={{ marginRight: 8 }}
                />
                {c.title} {c.priority === 1 ? '' : c.priority === 3 ? '' : ''}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      </div>
    );
  };

  // painel de detalhes para expand (joga colunas extras aqui)
  ExpandDetalhes = (row) => {
    var campos = [];
    for (var i = 0; i < this.columns.length; i++) {
      var c = this.columns[i];
      // Mostra tudo aqui (inclusive o que está escondido)
      var value = _.get(row, c.path);
      campos.push(
        <div
          key={c.path}
          style={{
            display: 'grid',
            gridTemplateColumns: '220px 1fr',
            padding: '4px 0',
            borderBottom: '1px solid #eee',
          }}
        >
          <div style={{ fontWeight: 'bold' }}>{c.title}</div>
          <div>{tableHelper.renderCustom(value, row, c)}</div>
        </div>
      );
    }
    return <div style={{ padding: 12 }}>{campos}</div>;
  };

  FilterWithChooser = (props) => {
    return (
      <React.Fragment>
        <PedidosCrudListFilter {...props} />
        {/* Chooser entra no mesmo grid do filtro */}
        <FormGroup className="col-12 col-md-3 d-flex align-items-end">
          {this.renderColumnChooser()}
        </FormGroup>
      </React.Fragment>
    );
  };

  render() {
    var visibleKeys = this.state.visibleKeys;

    // exemplo: substituir createdAt/updatedAt por um compacto (opcional)
    var columnsForRender = this.columns.slice(0);
    var idxCreated = _.findIndex(columnsForRender, function(c) {
      return c.path === 'createdAt';
    });
    var idxUpdated = _.findIndex(columnsForRender, function(c) {
      return c.path === 'updatedAt';
    });
    if (idxCreated > -1 && idxUpdated > -1) {
      // remove updatedAt da grade e deixa só no expand
      columnsForRender[idxUpdated].hidden = true;
      // usa formatter compacto em createdAt
      columnsForRender[idxCreated].customFormat = this.renderDatasCompact;
    }

    var tableColumns = _.map(columnsForRender, (column, index) => {
      var isHidden =
        column.hidden === true || visibleKeys[column.path] !== true;
      var formatFn = column.customFormat
        ? column.customFormat
        : tableHelper.renderCustom;

      return (
        <TableHeaderColumn
          key={index}
          dataField={column.path}
          dataFormat={formatFn}
          formatExtraData={column}
          isKey={column.isKey}
          dataSort={column.dataSort}
          hidden={isHidden}
          width={column.width}
          columnClassName={column.className}
          className={column.className}
        >
          {column.title}
        </TableHeaderColumn>
      );
    });

    var fields = _.map(this.columns, function(coluna) {
      return coluna.path;
    });
    var filter = {
      extension: this.props.extension
        ? this.props.extension
        : this.props.user
        ? this.props.user.extension
        : null,
    };

    return (
      <React.Fragment>
        <TopoTitleComponente mainTitle="Pedidos" subTitle=" " canBack={false} />

        <ListagemPage
          key="pedidos"
          pageFilter="pedidos"
          title={'Pedidos'}
          newButtonActionClick={this.handleNewButton}
          delete={function() {}}
          service={pedidosService}
          showNewButton={
            this.props.ability && this.props.ability.can('create', 'Pedido')
          }
          labelNewButton="Novo Pedido"
          defaultOrder={'nome'}
          defaultDirection={'asc'}
          defaultFilter={filter}
          onRowClick={this.handleRowClick}
          FormFilter={PedidosCrudListFilter}
          array={'pedidos'}
          renderRightOfSearch={this.renderColumnChooser}
          isExpandableRow={function() {
            return true;
          }}
          expandComponent={this.ExpandDetalhes}
          expandColumnOptions={{
            expandColumnVisible: true,
            expandColumnBeforeSelectColumn: true,
          }}
        >
          {tableColumns}
        </ListagemPage>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  var user = state && state.authentication ? state.authentication.user : null;
  return { user: user };
}

export default withAbility(
  connect(mapStateToProps)(withAbility(PedidosCrudList))
);
